<template>
	<div>
		<div class="container-fluid">
			<form class="form-horizontal">
				<div class="tabs text-center">
					<button
						@click.prevent="tab = 'main'"
						:class="tab === 'main' ? 'active' : ''"
						class="btn"
					>
						{{ 'General' | translate }}
					</button>
					<button
						@click.prevent="tab = 'secondary'"
						:class="tab === 'secondary' ? 'active' : ''"
						class="btn"
					>
						{{ 'Additional' | translate }}
					</button>
					<button
						@click.prevent="tab = 'financial'"
						:class="tab === 'financial' ? 'active' : ''"
						class="btn"
					>
						{{ 'Financial' | translate }}
					</button>
					<button
						@click.prevent="tab = 'documents'"
						:class="tab === 'documents' ? 'active' : ''"
						class="btn"
					>
						{{ 'Documents' | translate }}
					</button>
					<button
						v-if="myRole === 'super franchise'"
						@click.prevent="tab = 'comment'"
						:class="tab === 'comment' ? 'active' : ''"
						class="btn"
					>
						{{ 'Comment' | translate }}
					</button>
				</div>
				<div class="row">
					<div
						v-show="tab === 'main'"
						class="tab-content col-lg-6 col-md-8 mr-auto ml-auto col-sm-12"
					>
						<fieldset>
							<legend>{{ 'General information' | translate }}</legend>
							<div
								class="form-group"
								v-if="
									franchise.role === 'franchise' && myRole === 'super franchise'
								"
							>
								<label>{{ 'Master Franchise' | translate }}</label>
								<div>
									<v-select
										:value.sync="choosedMaster"
										:on-change="changeFranchise"
										:options="masterList"
									></v-select>
								</div>
							</div>
							<div class="form-group">
								<label>Email</label>
								<input
									v-model="franchise.email"
									:class="emailError ? 'error' : ''"
									type="email"
									class="form-control"
								/>
								<div class="text-right text-danger" v-if="emailError">
									{{ emailError }}
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'Phone number' | translate }}</label>
								<input
									:class="numberError ? 'error' : ''"
									v-model="franchise.phone_number"
									type="text"
									class="form-control"
								/>
								<div class="text-right text-danger" v-if="numberError">
									{{ numberError }}
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'Date of birth' | translate }}</label>
								<datepicker
									v-model="franchise.birthday"
									:format="format"
									class="-control"
								></datepicker>
							</div>
							<div class="form-group">
								<label>{{ 'First name' | translate }}</label>
								<input
									type="text"
									v-model="franchise.first_name"
									class="form-control"
								/>
							</div>
							<div class="form-group">
								<label>{{ 'Surname' | translate }}</label>
								<input
									type="text"
									v-model="franchise.middle_name"
									class="form-control"
								/>
							</div>
							<div class="form-group">
								<label>{{ 'Last name' | translate }}</label>
								<input
									type="text"
									v-model="franchise.last_name"
									class="form-control"
								/>
							</div>

							<legend>{{ 'Language' | translate }}</legend>
							<div class="form-check">
								<label class="form-check-label">
									<input
										type="radio"
										class="form-check-input"
										name="optionsRadios"
										v-model="franchise.eng_status"
										value="with"
										checked
									/>
									{{ 'With english' | translate }}
								</label>
							</div>
							<div class="form-check">
								<label class="form-check-label">
									<input
										type="radio"
										class="form-check-input"
										name="optionsRadios"
										v-model="franchise.eng_status"
										value="without"
									/>
									{{ 'Without english' | translate }}
								</label>
							</div>
							<div class="form-group">
								<label class="">{{ 'Default language' | translate }} *</label>
								<div class="">
									<select
										class="form-control"
										@change="$route.params.id === 'me' ? changeLang() : ''"
										v-model="franchise.default_language"
									>
										<option value="UA">UA</option>
										<option value="RU">RU</option>
										<option value="AZ">AZ</option>
										<option value="PL">PL</option>
										<option value="HE">HE</option>
										<option value="HY">HY</option>
										<option value="RO">RO</option>
										<option value="EN">EN</option>
										<option value="FR">FR</option>
										<option value="ES">ES</option>
										<option value="CS">CZ</option>
										<option value="DE">DE</option>
										<option value="IT">IT</option>
										<option value="TR">TR</option>
										<option value="EL">EL</option>
									</select>
								</div>
							</div>

							<div class="form-group">
								<label>Report email</label>

								<input
									v-model="franchise.report_email"
									type="email"
									class="form-control"
								/>

								<div
									class="text-right text-danger"
									v-if="franchise.report_email"
								>
									<div
										v-if="franchise.is_report_email_verified"
										class="text-success"
									>
										Email has already been verified
									</div>

									<div v-else>
										New email need to be verified
									</div>
								</div>
							</div>
						</fieldset>
					</div>
					<div
						v-show="tab === 'secondary'"
						class="tab-content col-lg-6 col-md-8 mr-auto ml-auto  col-sm-12"
					>
						<fieldset>
							<legend>{{ 'Additional information' | translate }}</legend>
							<div class="form-group">
								<label>{{ 'Region' | translate }}</label>
								<input
									type="text"
									v-model="franchise.region"
									class="form-control"
								/>
							</div>
							<div class="form-group">
								<label>{{ 'Passport' | translate }}</label>
								<textarea
									v-model="franchise.passport"
									class="form-control"
								></textarea>
							</div>
							<div class="form-group">
								<label>{{ 'Id code' | translate }}</label>
								<input
									type="text"
									v-model="franchise.tax_id"
									class="form-control"
								/>
							</div>
							<div class="form-group checkbox">
								<label>
									<input
										type="checkbox"
										:disabled="disabled"
										v-model="franchise.is_email_subscribed"
									/>
									{{ 'With email newsletter' | translate }}
								</label>
							</div>
						</fieldset>
					</div>
					<div
						v-show="tab === 'financial'"
						class="tab-content col-lg-6 col-md-8 mr-auto ml-auto col-sm-12"
					>
						<fieldset>
							<legend>{{ 'Financial information' | translate }}</legend>
							<div class="form-group">
								<label>{{ 'Royalty' | translate }}</label>
								<input
									type="number"
									:class="royaltyError ? 'error' : ''"
									@input="filterNegative('royalty')"
									:disabled="disabled"
									v-model="franchise.royalty"
									class="form-control"
								/>
								<div class="text-right text-danger" v-if="royaltyError">
									{{ royaltyError }}
								</div>
							</div>
							<div
								v-if="
									(franchise.royalty_en !== null ||
										myRole === 'super franchise') &&
										showEng &&
										franchise.eng_status === 'with'
								"
								class="form-group"
							>
								<label>{{ 'Royalty' | translate }} EN</label>
								<input
									type="number"
									:class="royaltyEnError ? 'error' : ''"
									@input="filterNegative('royalty_en')"
									:disabled="disabled"
									v-model="franchise.royalty_en"
									class="form-control"
								/>
								<div class="text-right text-danger" v-if="royaltyEnError">
									{{ royaltyEnError }}
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'Сost of education' | translate }}</label>
								<input
									type="number"
									:class="minPriceError ? 'error' : ''"
									:disabled="disabled"
									@input="filterNegative('price_min')"
									v-model="franchise.price_min"
									class="form-control"
								/>
								<div class="text-right text-danger" v-if="minPriceError">
									{{ minPriceError }}
								</div>
							</div>
							<div
								v-if="
									(franchise.price_min_en !== null ||
										myRole === 'super franchise') &&
										showEng &&
										franchise.eng_status === 'with'
								"
								class="form-group"
							>
								<label>{{ 'Сost of education' | translate }} EN</label>
								<input
									type="number"
									:disabled="disabled"
									:class="minPriceEnError ? 'error' : ''"
									v-model="franchise.price_min_en"
									@input="filterNegative('price_min_en')"
									class="form-control"
								/>
								<div class="text-right text-danger" v-if="minPriceEnError">
									{{ minPriceEnError }}
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'PR contribution' | translate }}</label>
								<input
									type="number"
									:class="prDepositError ? 'error' : ''"
									@input="filterNegative('pr_deposit')"
									:disabled="disabled"
									v-model="franchise.pr_deposit"
									class="form-control"
								/>
								<div class="text-right text-danger" v-if="prDepositError">
									{{ prDepositError }}
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'Currency' | translate }}</label>
								<select
									class="form-control"
									:disabled="disabled"
									v-model="franchise.currency"
								>
									<option>UAH</option>
									<option>USD</option>
									<option>RUB</option>
									<option>EUR</option>
									<option>PLN</option>
									<option>AZN</option>
									<option>NIS</option>
								</select>
							</div>
							<div class="form-group">
								<label>{{ 'Contract number' | translate }}</label>
								<input
									type="text"
									v-model="franchise.contract_number"
									:disabled="disabled"
									class="form-control"
								/>
							</div>
							<div class="form-group">
								<label>{{ 'Type of legal activity' | translate }}</label>
								<input
									type="text"
									v-model="franchise.legal_activity_type"
									:disabled="disabled"
									class="form-control"
								/>
							</div>
							<div class="form-group">
								<label>{{ 'Legal address' | translate }}</label>
								<input
									type="text"
									v-model="franchise.legal_address"
									:disabled="disabled"
									class="form-control"
								/>
							</div>
							<div class="form-group">
								<label>{{ 'Registration number' | translate }}</label>
								<input
									type="text"
									v-model="franchise.legal_id"
									:disabled="disabled"
									class="form-control"
								/>
							</div>
							<div class="form-group">
								<label>{{ 'МФО' | translate }}</label>
								<input
									type="text"
									v-model="franchise.mfo"
									:disabled="disabled"
									class="form-control"
								/>
							</div>
							<div class="form-group">
								<label>{{ 'Р/Р' | translate }}</label>
								<input
									type="text"
									v-model="franchise.settlement_account"
									:disabled="disabled"
									class="form-control"
								/>
							</div>
							<legend>{{ 'Discounts' | translate }}</legend>
							<p>{{ franchise.discounts }}</p>
							<legend>{{ 'Bonus days' | translate }}</legend>
							<p>{{ franchise.bonusDays }}</p>
							<legend>{{ 'Bonus weeks' | translate }}</legend>
							<p>{{ franchise.bonusWeeks }}</p>
						</fieldset>
					</div>
					<div
						v-show="tab === 'documents'"
						class="tab-content col-lg-6 col-md-8 mr-auto ml-auto col-sm-12"
					>
						<fieldset class="scans">
							<legend>{{ 'Documents' | translate }}</legend>
							<div class="form-group">
								<input
									type="file"
									@change="uploadImage"
									class="btn btn-secondary form-control-file"
								/>
							</div>
							<div v-for="file in fileList" :key="file.id" class="item row">
								<div class="col-sm-12 col-md-6">{{ file.name }}</div>
								<div class="actions col-md-6 col-sm-12">
									<a
										:href="'https://api.indigo.teeko.io' + file.file"
										download
										class="btn btn-success"
									>
										{{ 'Download' | translate }}
									</a>
									<button
										@click.prevent="deleteFile(file.id)"
										class="btn btn-danger"
									>
										{{ 'Remove' | translate }}
									</button>
								</div>
							</div>
						</fieldset>
					</div>
					<div
						v-if="myRole === 'super franchise'"
						v-show="tab === 'comment'"
						class="tab-content col-lg-6 col-md-8 mr-auto ml-auto col-sm-12"
					>
						<b>{{ 'Comment' | translate }}</b>
						<textarea
							class="form-control"
							v-model="franchise.comments"
						></textarea>
					</div>
					<div class="col-12 text-center">
						<input
							type="submit"
							:value="'Save' | translate"
							@click.prevent="changeProfile"
							class="btn btn-primary submit"
						/>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'

export default {
	name: 'Franchise',
	data() {
		return {
			format: 'dd/MM/yyyy',
			tab: 'main',
			fileList: [],
			disabled: false,
			idForImage:
				this.$route.params.id === 'me'
					? this.$store.state.myProfile.id
					: this.$route.params.id,
			myRole: this.$store.state.myProfile.role,
			emailError: '',
			reportEmailError: '',
			numberError: '',
			royaltyError: '',
			royaltyEnError: '',
			minPriceEnError: '',
			minPriceError: '',
			prDepositError: '',
			showEng: true,
			masterList: [],
			discounts: [],
			choosedMaster: '',

			// report_email: "",
			// is_report_email_verified: false,
		}
	},
	components: {
		Datepicker,
		vSelect,
	},
	computed: {
		franchise() {
			return this.$store.state.profile
		},
	},

	methods: {
		changeLang() {
			window.localStorage.setItem(
				'defaultLanguage',
				this.franchise.default_language.toLowerCase()
			)
			this.$i18n.set(this.franchise.default_language.toLowerCase())
		},
		changeFranchise(val) {
			if (val !== null) {
				this.franchise.parent = val.value
			}
		},
		deleteFile(fileId) {
			this.axios({
				method: 'delete',
				url: `billing/files/${fileId}`,
			}).then(response => {
				this.reloadDocuments()
			})
		},
		uploadImage(e) {
			let files = e.target.files
			let data = new FormData()
			for (var i = 0; i < files.length; i++) {
				let file = files.item(i)
				data.append(file.name, file, file.name)
			}
			const config = {
				headers: {
					'content-type': 'multipart/form-data',
				},
			}
			return this.axios
				.post(`billing/files?uploaded_by=${this.idForImage}`, data, config)
				.then(response => {
					this.reloadDocuments()
				})
		},
		reloadDocuments() {
			this.axios({
				method: 'get',
				url: `billing/files?user=${this.idForImage}`,
			}).then(response => {
				this.fileList = response.data
			})
		},
		updateInfo() {
			let profile = this.$store.state.profile
			let role = profile.role
			this.reloadDocuments()
			if (role === 'franchise' && this.myRole === 'super franchise') {
				this.axios({
					method: 'get',
					url: 'users?role=master franchise',
				}).then(response => {
					let masterArray = response.data
					for (var i = 0; i < masterArray.length; i++) {
						let master = {
							value: masterArray[i].id,
							label:
								masterArray[i].last_name +
								' ' +
								masterArray[i].first_name +
								' ' +
								masterArray[i].middle_name,
						}
						this.masterList.push(master)
					}
				})
				this.axios({
					method: 'get',
					url: `users/user/${profile.parent}`,
				}).then(response => {
					this.choosedMaster =
						response.data.last_name +
						' ' +
						response.data.first_name +
						' ' +
						response.data.middle_name
				})
			}
			if (role === 'master franchise' && this.myRole !== 'super franchise') {
				this.disabled = true
			} else if (role === 'franchise' && this.myRole === 'franchise') {
				this.disabled = true
			}
			if (
				role === 'master franchise' &&
				this.myRole !== 'super franchise' &&
				(profile.royalty_en === null || profile.royalty_en === '')
			) {
				this.showEng = true
			} else if (
				role === 'franchise' &&
				this.myRole === 'franchise' &&
				(profile.royalty_en === null || profile.royalty_en === '')
			) {
				this.showEng = true
			} else if (role === 'franchise' && this.myRole !== 'franchise') {
				this.axios({
					method: 'get',
					url: `users/user/${profile.parent}`,
				}).then(response => {
					if (
						response.data.royalty_en === '' ||
						response.data.royalty_en === null
					) {
						this.showEng = true
					}
				})
			}
		},
		filterNegative(prop) {
			if (this.franchise[prop] < 0) {
				this.franchise[prop] = 0
			} else if (
				(prop === 'royalty' ||
					prop === 'royalty_en' ||
					prop === 'pr_deposit') &&
				this[prop] > 100
			) {
				this.franchise[prop] = 100
			}
		},
		changeProfile() {
			let error = false
			this.emailError = ''
			this.numberError = ''
			this.royaltyError = ''
			this.royaltyEnError = ''
			this.minPriceEnError = ''
			this.minPriceError = ''
			this.prDepositError = ''

			if (this.franchise.email === '') {
				this.emailError = this.$t('Field required')
				error = true
			}

			if (this.franchise.phone_number === '') {
				this.numberError = this.$t('Field required')
				error = true
			}

			if (this.franchise.royalty === '' || this.franchise.royalty === null) {
				this.royaltyError = this.$t('Field required')
				error = true
			}

			if (
				(this.franchise.royalty_en === '' || this.royaltyEn === null) &&
				this.showEng &&
				this.franchise.eng_status === 'with'
			) {
				this.royaltyEnError = this.$t('Field required')
				error = true
			}

			if (
				(this.franchise.price_min_en === '' ||
					this.franchise.price_min_en === null) &&
				this.showEng &&
				this.franchise.eng_status === 'with'
			) {
				this.minPriceEnError = this.$t('Field required')
				error = true
			}

			if (
				this.franchise.price_min === '' ||
				this.franchise.price_min === null
			) {
				this.minPriceError = this.$t('Field required')
				error = true
			}

			if (
				this.franchise.pr_deposit === '' ||
				this.franchise.pr_deposit === null
			) {
				this.prDepositError = this.$t('Field required')
				error = true
			}

			if (error) {
				return false
			}

			let birthday = null
			let method = 'post'

			if (this.$route.params.id !== 'me') {
				method = 'patch'
			}

			if (
				this.franchise.birthday !== null &&
				this.franchise.birthday !== '' &&
				this.franchise.birthday.length !== 10
			) {
				birthday = this.franchise.birthday.toISOString().slice(0, 10)
			}

			this.axios({
				method: method,
				url: `users/user/${this.$route.params.id}`,
				data: {
					email: this.franchise.email,
					phone_number: this.franchise.phone_number,
					first_name: this.franchise.first_name,
					middle_name: this.franchise.middle_name,
					last_name: this.franchise.last_name,
					passport: this.franchise.passport,
					region: this.franchise.region,
					tax_id: this.franchise.tax_id,
					is_email_subscribed: this.franchise.is_email_subscribed,
					royalty: Number(this.franchise.royalty),
					royalty_en: Number(this.franchise.royalty_en),
					pr_deposit: this.franchise.pr_deposit,
					currency: this.franchise.currency.toLowerCase(),
					mfo: this.franchise.mfo,
					settlement_account: this.franchise.settlement_account,
					legal_id: this.franchise.legal_id,
					legal_address: this.franchise.legal_address,
					legal_activity_type: this.franchise.legal_activity_type,
					price_min: Number(this.franchise.price_min),
					price_min_en: Number(this.franchise.price_min_en),
					comments: this.franchise.comments,
					birthday: birthday,
					contract_number: this.franchise.contract_number,
					parent: this.franchise.parent,
					eng_status: this.franchise.eng_status,
					default_language: this.franchise.default_language,
					report_email: this.franchise.report_email,
				},
			})
				.then(response => {
					this.$toast(this.$t('Changes saved'), {
						className: ['btn-success', 'notif'],
						duration: 3000,
					})
				})
				.catch(error => {
					if (error.response.data.phone_number) {
						this.numberError = this.$t(error.response.data.phone_number[0])
					}

					if (error.response.data.email) {
						this.emailError = this.$t(error.response.data.email[0])
					}

					if (error.response.data.detail) {
						this.emailError = this.$t(error.response.data.detail[0])
					}
				})
		},
	},
	created() {
		this.updateInfo()
	},

	watch: {
		$route(from, to) {
			this.updateInfo()
		},
	},
}
</script>

<style scoped>
.nav-pills li {
	margin: 10px;
}

.submit {
	margin-top: 20px;
	margin-bottom: 20px;
}

.nav-pills {
	flex-wrap: wrap;
}

nav {
	margin: 50px auto;
}

.tabs .btn {
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0;
}

.tabs .active {
	background-color: #fff;
}

.tab-content {
	border: 1px solid buttonface;
	border-radius: 10px;
	background: #fff;
	padding-top: 30px;
	padding-bottom: 30px;
}

span {
	margin-bottom: 20px;
	display: block;
}
</style>
